import { colorsPalettes } from "@similarweb/styles";

import { ArrowSvg } from "./styled";

interface IArrowProps {
    color?: string;
    direction?: "up" | "down";
    size?: number;
    className?: string;
}

export const Arrow = ({
    color = colorsPalettes.green["400_P"],
    direction = "up",
    size = 16,
    className = "",
}: IArrowProps) => {
    return (
        <ArrowSvg
            width={size}
            height={size}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            $direction={direction}
            viewBox="0 0 16 16"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.66702 1.99991L4.5 6.08627L5.10216 6.69572L8.23752 3.62196V13.6667H9.09567V3.62196L12.231 6.69572L12.8332 6.08627L8.66702 1.99991Z"
                fill={color}
            />
        </ArrowSvg>
    );
};
